module.exports = __webpack_public_path__ + "static/media/me.42a4ee85.png";